const tryUntil = ({ check, onAble, unless }) => {
  let interval;

  return function (...args) {
    interval = setInterval(() => {
      if (unless(...args)) return clearInterval(interval);

      const able = check(...args);
      if (!able) return;

      clearInterval(interval);
      return onAble.call(this, ...args);
    }, 300);
  };
};

const openChatFeature = () => GorgiasChat.open();

const tryUntilOpenChat = tryUntil({
  check: () => Boolean(document.querySelector("#chat-button")),
  unless: (url_string) => {
    const url = new URL(url_string);
    const shouldOpenChat = url.searchParams.get("openChat") === "true";
    return !shouldOpenChat;
  },
  onAble: openChatFeature,
});

// Put your application javascript here
$(function () {
  $(".searchToggle").click(function () {
    $(".search-container").toggleClass("activated");
    $(".slmdnav").toggleClass("activated");
  });

  $(".product-carousel-container").slick({
    arrows: true,
    dots: false,
    pauseOnHover: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: false,
    centerMode: false,
    prevArrow: $(".pccPrevArrow"),
    nextArrow: $(".pccNextArrow"),
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 3,
          infinite: false,
          arrows: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2,
          infinite: false,
          arrows: false,
        },
      },
    ],
  });
  loginForms();
  tryUntilOpenChat.call(this, window.location.href);
});

/* RE-CONVERTED TIMBER JS FOR CUSTOMER FILES */
var loginForms = function () {
  function showRecoverPasswordForm() {
    $("#RecoverPasswordForm").show();
    $("#CustomerLoginForm").hide();
  }

  function hideRecoverPasswordForm() {
    $("#RecoverPasswordForm").hide();
    $("#CustomerLoginForm").show();
  }

  $("#RecoverPassword").on("click", function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
    console.log("RecoverPassword");
  });

  $("#HideRecoverPasswordLink").on("click", function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (window.location.hash == "#recover") {
    showRecoverPasswordForm();
  }
};

var resetPasswordSuccess = function () {
  $("#ResetSuccess").show();
};

//loginForms();
